import React, {Component} from 'react';
import * as firebase from 'firebase';
import './hall-editor.css';

/** @class HallMetadata
  * A component for editing the metadata of a hall
  * in a virtual expo.
  */
export default class HallMetadata extends Component {
  /** @constructor
    * Creates a new instance of the component.
    */
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      published: false
    }
    this.firebaseRef = firebase.database().ref(this.props.dataURL);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
  }
  /** @function componentWillMount
    * Connects the component to the corresponding firebase
    * realtime database entry
    */
  componentWillMount(){
    this.firebaseRef.on('value', snapshot =>{
      this.setState(snapshot.val());
    });
  }
  /** @function componentWillUnmount
    * Disconnects the component from the firebase database.
    */
  componentWillUnmount(){
    this.firebaseRef.off();
  }
  /** @function handleChange
    * Updates the component state to reflect changes
    * in input fields.
    * @param {InputEvent} event - the change event
    */
  handleChange(event) {
    const target = event.target;
    const value = target.type === 'checkbox' ? target.checked : target.value;
    const name = target.name;
    this.setState({
      [name]: value
    });
  }
  /** @function handleBlur
    * Applies the updated state to the firebase database
    */
  handleBlur() {
    this.firebaseRef.set(this.state);
  }
  /** @function render
    * renders the component.
    */
  render() {
    return (
      <div className="metadata-panel">
        <div className="metadata-column">
          <div className="input-group">
            <label htmlFor="name">Name</label><br/>
            <input type="text" name="name"
              value={this.state.name}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              />
          </div>
          <div className="input-group">
            <label htmlFor="published">
            <input type="checkbox" name="published"
              checked={this.state.published}
              onChange={this.handleChange}
              onBlur={this.handleBlur}
              />
              Published
            </label>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/hall-editor/hall-metadata.js